var module = angular.module('octopusApp.library');

module.controller('PackageVersionsController', function($scope, $location, busy, $stateParams, $state, octopusRepository, octoDialog) {
  var isLoading = $scope.isLoading = busy.create();

  var packageId = $stateParams["packageId"];
  $scope.routePackageId = packageId;

  isLoading.promise(octopusRepository.Packages.list({ nuGetPackageId: packageId }).then(function(versions){
    $scope.package = versions.Items[0];
    $scope.packageVersions = versions;
    $scope.view = { allSelected: false };
    $scope.noneSelected = function() {
      if (_.find($scope.packageVersions.Items, function(item){ return item.IsSelected; })) {
        return false;
      }
      return true;
    };
    $scope.$watch("view.allSelected", function(nv){
      if (!nv) {
        if (_.find($scope.packageVersions.Items, function(item){ return !item.IsSelected; })){
          return;
        }
      }
      _.each($scope.packageVersions.Items, function(item){
        item.IsSelected = nv;
      });
    });

    $scope.deleteSelected = function() {
      var w = 'Deleting packages will permanently remove files from disk. Are you sure you want to delete these packages?';
      var packageIds = _.map(
        _.filter(
          $scope.packageVersions.Items,
          function(item) { return item.IsSelected; }),
        function(item){
          return item.Id;
        }).join(',');

      octoDialog.asyncConfirm({
        title: "Delete packages",
        message: w,
        executeButtonClass: "btn-warning",
        executeButtonText: "Delete",
        execute: function (dialog) {
          dialog.busy.promise(octopusRepository.Packages.deleteMany(packageIds).then(function () {
            dialog.dismiss();
            $state.reload();
          }));
        }
      });
    };
  }));
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/library/packages/controllers/package_versions_controller.js
// module id = 6244152051911627
// module chunks = 1